import React from 'react'

import * as styles from 'modules/resultsV2/ResultMeta.styles'
import { DEFAULT_DATA_ACCESS_REQUEST_DATASET_COLOR } from 'modules/resultsV2/utils'

export const TEST_ID_DATA_ACCESS_REQUEST_DATASET_COLOR = 'dataset-color-indicator'

export interface DatasetChipProps {
  name: string
  color?: string
  /** Trails the name, e.g. a participant count. */
  children?: React.ReactNode
}

/**
 * A dataset, wherever one is named: its colour swatch, its name, and anything that trails it.
 * One component so a dataset looks the same on the request and on its related requests.
 */
export const DatasetChip = ({
  name,
  color = DEFAULT_DATA_ACCESS_REQUEST_DATASET_COLOR,
  children
}: DatasetChipProps): JSX.Element => (
  <styles.DatasetValue>
    <styles.DatasetColorIndicator $color={color} aria-hidden data-testid={TEST_ID_DATA_ACCESS_REQUEST_DATASET_COLOR} />
    <span>{name}</span>
    {children}
  </styles.DatasetValue>
)
